var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgEfficiencyratio = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "device/outline/flash"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 2750",
    d: "M5 13.5L14 2V10.5H19L10 22V13.5H5Z",
    stroke: "#DD9296",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgEfficiencyratio);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/efficiencyratio.7c315ef4cd9c2ae2fdf72203183b75b3.svg";